var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h5", { staticClass: "grey-color fw-600" }, [
        _vm._v("Измените спецификацию"),
      ]),
      _c(
        "fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table",
        {
          attrs: { v: _vm.$v.form.deliverables, "is-loading": _vm.isLoading },
          model: {
            value: _vm.form.deliverables,
            callback: function ($$v) {
              _vm.$set(_vm.form, "deliverables", $$v)
            },
            expression: "form.deliverables",
          },
        }
      ),
      _vm.$v.form.deliverables.$invalid
        ? _c(
            "b-form-invalid-feedback",
            {
              staticClass: "my-2",
              staticStyle: { "padding-left": "5px", "padding-right": "5px" },
              attrs: { state: !_vm.$v.form.deliverables.$invalid },
            },
            [_vm._v(_vm._s(_vm.specErrorMessage))]
          )
        : _vm._e(),
      _c("text-row-price", {
        attrs: {
          "label-cols-lg": 4,
          label: "Общая стоимость, руб.",
          value: _vm.specSum,
        },
      }),
      _c("text-row-price", {
        attrs: {
          "label-cols-lg": 4,
          label: "Общая стоимость контракта, руб.",
          value: _vm.purchase.purchase_terms.contract_price,
        },
      }),
      _c("form-row-edit-date", {
        attrs: {
          "label-cols-lg": 4,
          label: "Дата заключения дополнительного соглашения",
          v: _vm.$v.form.conclusion_date,
          "min-date": _vm.purchase.contract.contract_conclusion_date,
          "max-date": _vm.$now(),
          compact: "",
        },
        model: {
          value: _vm.form.conclusion_date,
          callback: function ($$v) {
            _vm.$set(_vm.form, "conclusion_date", $$v)
          },
          expression: "form.conclusion_date",
        },
      }),
      _c("form-row-single-line-document-upload", {
        attrs: {
          "label-cols-lg": 4,
          v: _vm.$v.form.attachment,
          title: "Дополнительное соглашение",
          compact: "",
        },
        model: {
          value: _vm.form.attachment,
          callback: function ($$v) {
            _vm.$set(_vm.form, "attachment", $$v)
          },
          expression: "form.attachment",
        },
      }),
      _c(
        "b-button",
        {
          staticClass: "text-uppercase mt-2",
          attrs: { variant: "custom-outline-secondary" },
          on: { click: _vm.onCancel },
        },
        [_vm._v("Отмена")]
      ),
      _c(
        "b-button",
        {
          staticClass: "text-uppercase mt-2 ml-2",
          attrs: { variant: "custom-green", disabled: _vm.$v.$invalid },
          on: { click: _vm.createSupplementaryAgreement },
        },
        [_vm._v("Отправить дополнительное соглашение поставщику")]
      ),
      _c("p", { staticClass: "font-weight-bold text-danger mt-3 mb-1 fs-14" }, [
        _vm._v(
          "Внимание! Для данной закупки будут заблокированы функции: изменение лимитов, добавление дополнительного соглашения, изменение статуса."
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }